import { Box, Typography } from "@mui/material";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";

/**
 * A seller's delivery instructions (delivery area, fees by region...), shown
 * wherever delivery is offered.
 */
const DeliveryInstructionsBox = ({
  instructions,
  title = "Delivery info",
  sx,
}) => {
  if (!instructions) return null;
  return (
    <Box sx={{ p: 1.5, bgcolor: "#f4f4f4", borderRadius: 2, ...sx }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, mb: 0.5 }}>
        <LocalShippingOutlinedIcon sx={{ fontSize: 16, color: "#046287" }} />
        <Typography variant="caption" fontWeight={700}>
          {title}
        </Typography>
      </Box>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ whiteSpace: "pre-wrap", lineHeight: 1.7 }}
      >
        {instructions}
      </Typography>
    </Box>
  );
};

export default DeliveryInstructionsBox;
